import { UnstyledButton as UnstyledButtonComponent } from '@mantine/core'

import styles from './unstyled-button.module.scss'

export const UnstyledButton = UnstyledButtonComponent.extend({
  classNames: {
    root: styles.root,
  },
})
